// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description Model representing a document added to a template
*/
export class TCQpSignatureModelEnterpriseDBDocument {
    /**
    * @description Enterprise DB Document Id
    */
    'enterpriseDBDocumentId': number;
    /**
    * @description Sequence
    */
    'sequence': number;
    /**
    * @description File Name
    */
    'fileName': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TCQpSignatureModelEnterpriseDBDocument>> = [
        {
            "name":     "enterpriseDBDocumentId",
            "baseName": "enterpriseDBDocumentId",
            "type":     "number"
        },
        {
            "name":     "sequence",
            "baseName": "sequence",
            "type":     "number"
        },
        {
            "name":     "fileName",
            "baseName": "fileName",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return TCQpSignatureModelEnterpriseDBDocument.attributeTypeMap;
    }
}
